import { useLanguage } from "../context/LanguageContext";
import imageSources from "../i18n/images";

const useLocalizedImage = () => {
  const { locale } = useLanguage();

  const getImage = (imageKey) => {
    const sources = imageSources[locale] || imageSources.en; // Fallback to English if locale not found
    const imageSrc = sources[imageKey];
    if (!imageSrc) {
      console.error(
        `Image not found for key: ${imageKey} in locale: ${locale}`
      );
      return "/images/placeholder.png"; // Fallback image if not found
    }
    return imageSrc;
  };

  return getImage;
};

export default useLocalizedImage;
